<ng-content></ng-content>

<div data-testid="side-navigation-menu-menu-container" class="menu-container">
  <dx-tree-view data-testid="side-navigation-menu-tree-view"
    [items]="items"
    keyExpr="path"
    selectionMode="single"
    [focusStateEnabled]="false"
    expandEvent="click"
    (onItemClick)="onItemClick($event)"
    width="100%">
    <div *dxTemplate="let item of 'item'">
      <span class="icon-badge-wrapper" style="vertical-align: middle; display: inline-block; width: 24px; height: 24px; position: relative;">
        <i class="dx-icon-{{item.icon}}" class="dx-icon" [attr.title]="item.hint" style="font-size: 20px; line-height: 24px; vertical-align: middle;"></i>
        <ng-container *ngIf="item.showBadge">
          <span class="badge badge-overlay"
            style="position: absolute; top: -4px; right: -6px; min-width: 16px; height: 16px; padding: 0 4px; font-size: 10px; background: #cc171f; color: #fff; border-radius: 8px; display: flex; align-items: center; justify-content: center; pointer-events: none; z-index: 1;">
            {{ badgeData[item.badge]}}
          </span>
        </ng-container>
      </span>
      <span *ngIf="!compactMode" [attr.title]="item.hint" style="margin-left: 20px;">{{ item.text }}</span>
    </div>
  </dx-tree-view>
</div>
